import React, { Component } from "react";
import AntdEmpty, {EmptyProps} from 'antd/lib/empty';
import 'antd/lib/empty/style';

export default class Empty extends Component<EmptyProps> {
    render() {
        return (
          <AntdEmpty {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/empty/index.tsx